import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductStore } from '../../core/models/interfaces-general';
import { ProductCardStoreComponent } from '../catalogo/components/product-card-store.component';

@Component({
    selector: 'app-product-related-section',
    standalone: true,
    imports: [CommonModule, ProductCardStoreComponent],
    template: `
    <section class="w-full py-8 flex flex-col gap-6">
      <!-- ENCABEZADO -->
      <div class="flex flex-col items-center gap-1">
        <h2 class="text-2xl font-bold text-gray-800">Productos Relacionados</h2>
        <div class="w-12 h-1 bg-rose-500 rounded-full"></div>
      </div>

      <!-- GRILLA REUTILIZANDO PRODUCT-CARD-STORE -->
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
        <app-product-card-store 
          *ngFor="let item of relatedProducts" 
          [product]="item"
        ></app-product-card-store>
      </div>
    </section>
  `
})
export class ProductRelatedSectionComponent {
    @Input({ required: true }) relatedProducts: ProductStore[] = [];
}